
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire63a3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire63a3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("55Cur", function(module, exports) {

$parcel$export(module.exports, "lookupPin", function () { return $4e896999f98bfc32$export$f4bf0ce4c768966a; });
$parcel$export(module.exports, "completePin", function () { return $4e896999f98bfc32$export$3a7619233730fa0d; });

var $50Y1I = parcelRequire("50Y1I");
const $4e896999f98bfc32$export$f4bf0ce4c768966a = async (pin)=>{
    const response = await fetch((0, $50Y1I.getBackendUrl)(`/link-buy/lookup/${pin}`));
    if (!response.ok) throw new Error('Ongeldige PIN of serverfout');
    return response.json();
};
const $4e896999f98bfc32$export$3a7619233730fa0d = async (pin)=>{
    try {
        await fetch((0, $50Y1I.getBackendUrl)('/link-buy/complete'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pin: pin
            })
        });
    } catch (error) {
        console.warn('Failed to complete PIN:', error);
    }
};

});
parcelRegister("50Y1I", function(module, exports) {

$parcel$export(module.exports, "getCleengScriptUrl", function () { return $84ebfcfe7f2e8f63$export$534df171cc4cb762; });
$parcel$export(module.exports, "getBackendUrl", function () { return $84ebfcfe7f2e8f63$export$580109732c057b1e; });
const $84ebfcfe7f2e8f63$var$getCleengEnvFromDomain = ()=>{
    const hostname = window.location.hostname;
    return hostname === "betalen.talpanetwork.com" ? "prod" : "sandbox";
};
const $84ebfcfe7f2e8f63$export$e506a1d27d1eaa20 = {
    cleengEnv: $84ebfcfe7f2e8f63$var$getCleengEnvFromDomain(),
    backendBaseUrl: undefined
};
const $84ebfcfe7f2e8f63$export$534df171cc4cb762 = ()=>{
    return $84ebfcfe7f2e8f63$export$e506a1d27d1eaa20.cleengEnv === "prod" ? "https://widgets.prod.cleeng.com/cleeng.js" : "https://widgets.sandbox.cleeng.com/cleeng.js";
};
const $84ebfcfe7f2e8f63$export$580109732c057b1e = (path)=>{
    return $84ebfcfe7f2e8f63$export$e506a1d27d1eaa20.backendBaseUrl ? `${$84ebfcfe7f2e8f63$export$e506a1d27d1eaa20.backendBaseUrl}${path}` : path;
};

});


parcelRegister("62ULh", function(module, exports) {

$parcel$export(module.exports, "setPinCookie", function () { return $49b3d5df2a9d9fb2$export$734aef5493aef17; });
$parcel$export(module.exports, "setDeviceTypeCookie", function () { return $49b3d5df2a9d9fb2$export$bddc9a073a86a89; });
$parcel$export(module.exports, "getPinFromCookie", function () { return $49b3d5df2a9d9fb2$export$59063d2b3e8f2e4f; });
const $49b3d5df2a9d9fb2$export$110700823644f4a6 = (name, value, minutes)=>{
    const expires = new Date();
    expires.setTime(expires.getTime() + minutes * 60000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
};
const $49b3d5df2a9d9fb2$export$4be65e66cfa2648a = (name)=>{
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $49b3d5df2a9d9fb2$export$734aef5493aef17 = (pin)=>{
    $49b3d5df2a9d9fb2$export$110700823644f4a6('ppv_pin', pin, 15);
};
const $49b3d5df2a9d9fb2$export$bddc9a073a86a89 = (deviceType)=>{
    $49b3d5df2a9d9fb2$export$110700823644f4a6('ppv_device_type', deviceType, 15);
};
const $49b3d5df2a9d9fb2$export$59063d2b3e8f2e4f = ()=>{
    return $49b3d5df2a9d9fb2$export$4be65e66cfa2648a('ppv_pin');
};

});


var $55Cur = parcelRequire("55Cur");

var $50Y1I = parcelRequire("50Y1I");
const $56ee70edf1fc2551$export$6b03db952f35a1be = ()=>{
    return new Promise((resolve, reject)=>{
        if (window.cleeng) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = (0, $50Y1I.getCleengScriptUrl)();
        script.async = true;
        const timeout = setTimeout(()=>{
            reject(new Error('Cleeng script laadtijd overschreden'));
        }, 10000);
        script.onload = ()=>{
            clearTimeout(timeout);
            // Wait for cleeng object to be available
            const checkCleeng = ()=>{
                if (window.cleeng) resolve();
                else setTimeout(checkCleeng, 100);
            };
            checkCleeng();
        };
        script.onerror = ()=>{
            clearTimeout(timeout);
            reject(new Error('Cleeng script laden mislukt'));
        };
        document.head.appendChild(script);
    });
};
const $56ee70edf1fc2551$export$8eb84bf3dc347d62 = (data)=>{
    if (!window.cleeng) throw new Error('Cleeng niet geladen');
    window.cleeng.setAuthTokens({
        jwt: data.jwt,
        refreshToken: data.refreshToken
    });
    const container = document.getElementById('cleeng-widget');
    if (!container) throw new Error('Widget container niet gevonden');
    container.innerHTML = `
    <div 
      data-cleeng-widget="checkout"
      data-cleeng-publisher-id="${data.publisherId}"
      data-cleeng-offer-id="${data.offerId}"
      data-cleeng-language="nl-NL">
    </div>
  `;
};



var $62ULh = parcelRequire("62ULh");
const $dfb036001283cfce$var$pinForm = document.getElementById('pin-form');
const $dfb036001283cfce$var$loadingDiv = document.getElementById('loading');
const $dfb036001283cfce$var$widgetDiv = document.getElementById('cleeng-widget');
const $dfb036001283cfce$var$form = document.getElementById('checkout-form');
const $dfb036001283cfce$var$pinInputs = document.querySelectorAll('input[data-index]');
const $dfb036001283cfce$var$submitBtn = document.getElementById('submit-btn');
const $dfb036001283cfce$var$errorDiv = document.getElementById('error-message');
const $dfb036001283cfce$var$showError = (message)=>{
    $dfb036001283cfce$var$errorDiv.textContent = message;
    $dfb036001283cfce$var$errorDiv.classList.remove('hidden');
};
const $dfb036001283cfce$var$hideError = ()=>{
    $dfb036001283cfce$var$errorDiv.classList.add('hidden');
};
const $dfb036001283cfce$var$getPinValue = ()=>{
    return Array.from($dfb036001283cfce$var$pinInputs).map((input)=>input.value).join('');
};
const $dfb036001283cfce$var$setPinValue = (pin)=>{
    Array.from($dfb036001283cfce$var$pinInputs).forEach((input, index)=>{
        input.value = pin[index] || '';
    });
};
const $dfb036001283cfce$var$validatePin = (pin)=>{
    return /^\d{6}$/.test(pin);
};
const $dfb036001283cfce$var$handleSubmit = async (pin)=>{
    if (!$dfb036001283cfce$var$validatePin(pin)) {
        $dfb036001283cfce$var$showError('PIN moet 6 cijfers bevatten');
        return;
    }
    $dfb036001283cfce$var$hideError();
    $dfb036001283cfce$var$pinForm.classList.add('hidden');
    $dfb036001283cfce$var$loadingDiv.classList.remove('hidden');
    try {
        const data = await (0, $55Cur.lookupPin)(pin);
        (0, $62ULh.setPinCookie)(data.pin);
        (0, $62ULh.setDeviceTypeCookie)(data.deviceType);
        await (0, $56ee70edf1fc2551$export$6b03db952f35a1be)();
        (0, $56ee70edf1fc2551$export$8eb84bf3dc347d62)(data);
        $dfb036001283cfce$var$loadingDiv.classList.add('hidden');
        $dfb036001283cfce$var$widgetDiv.classList.remove('hidden');
    } catch (error) {
        $dfb036001283cfce$var$loadingDiv.classList.add('hidden');
        $dfb036001283cfce$var$pinForm.classList.remove('hidden');
        $dfb036001283cfce$var$showError(error instanceof Error ? error.message : 'Er is een fout opgetreden');
    }
};
// Check for PIN in URL parameter
const $dfb036001283cfce$var$urlParams = new URLSearchParams(window.location.search);
const $dfb036001283cfce$var$urlPin = $dfb036001283cfce$var$urlParams.get('pin');
if ($dfb036001283cfce$var$urlPin) {
    $dfb036001283cfce$var$setPinValue($dfb036001283cfce$var$urlPin);
    $dfb036001283cfce$var$handleSubmit($dfb036001283cfce$var$urlPin);
}
// Form submission handler
$dfb036001283cfce$var$form.addEventListener('submit', (e)=>{
    e.preventDefault();
    const pin = $dfb036001283cfce$var$getPinValue();
    $dfb036001283cfce$var$handleSubmit(pin);
});
// PIN input handling
$dfb036001283cfce$var$pinInputs.forEach((input, index)=>{
    input.addEventListener('input', (e)=>{
        const target = e.target;
        const value = target.value.replace(/\D/g, '');
        target.value = value;
        // Auto-focus next input
        if (value && index < $dfb036001283cfce$var$pinInputs.length - 1) $dfb036001283cfce$var$pinInputs[index + 1].focus();
        // Auto-submit when last digit is entered
        if (value && index === $dfb036001283cfce$var$pinInputs.length - 1) {
            const pin = $dfb036001283cfce$var$getPinValue();
            if ($dfb036001283cfce$var$validatePin(pin)) $dfb036001283cfce$var$handleSubmit(pin);
        }
    });
    input.addEventListener('keydown', (e)=>{
        // Handle backspace to focus previous input
        if (e.key === 'Backspace' && !input.value && index > 0) $dfb036001283cfce$var$pinInputs[index - 1].focus();
    });
});


//# sourceMappingURL=link-buy-ui.0d35b15e.js.map
